import React, { FC } from 'react';

import { IconProps } from 'types/components';

import CardIcon from './CardIcon';

const UnknownCard: FC<IconProps> = (props) => (
  <CardIcon {...props}>
    <rect width="208" height="134" x="1" y="1" fill="#e8e8e8" rx="24" />
  </CardIcon>
);

export default UnknownCard;
